import React, {PropsWithChildren} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {IDialogConfirmationHandler} from "../../../services/dialog/dialog.service.interface";
import {composeModalId} from "../content/compose-modal-id";

const StandardDialogPageBox = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;

    & * {
        box-sizing: border-box;
        line-height: 1;
    }
`

interface StandardDialogPageComponentProps extends PropsWithChildren {
    dialogHandler: IDialogConfirmationHandler;
}

export const StandardDialogPageComponent: React.FC<StandardDialogPageComponentProps> = observer((props) => {
    return (
        <StandardDialogPageBox id={composeModalId(props.dialogHandler.id)}>
            {props.children}
        </StandardDialogPageBox>
    );
});
